var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
            React.createElement("path", { d: "M9.06 25.255l3.222.004c.739.987 2.379 1.676 3.994 1.676 1.609 0 3.261-.684 4.013-1.665l12.584.017c.557 0 1.013.437 1.055.99l.003.084v7.349c0 .565-.43 1.028-.976 1.07l-.083.004H19.459C19.087 36.129 17.692 37 16.222 37c-1.47 0-2.864-.87-3.237-2.216H9.06a1.065 1.065 0 01-1.056-.99L8 33.71v-7.382l.003-.085c.041-.525.454-.943.97-.985l.088-.003zM9.06 13l29.882.033c.557 0 1.013.437 1.055.99l.003.084v7.327a1.07 1.07 0 01-.977 1.07l-.082.004-19.48.013c-.37 1.35-1.766 2.224-3.239 2.224-1.47 0-2.866-.872-3.237-2.22l-3.926.003-.083-.002a1.066 1.066 0 01-.973-.982L8 21.455v-7.381l.003-.085c.04-.525.453-.943.97-.986L9.06 13z", fill: "currentColor" }))));
});
